import { useRuntimeVariables } from 'app-kit'
import { isDomesticCommercialUser } from 'features/auth'

/**
 * If the user can visit the site view.
 *
 * This function checks if the current environment is not a government environment (to exclude Gov users),
 * and that it is not running in SecondFront (to exclude UAE users).
 */
export function useCanVisitSiteView(): boolean {
  const { ENVIRONMENT, RUNNING_ON } = useRuntimeVariables()
  return isDomesticCommercialUser(ENVIRONMENT, RUNNING_ON)
}
